/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownLocalPartner } from '../models/db_DropdownLocalPartner';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocalPartners {
    /**
     * Get a list of local partners
     * @returns db_DropdownLocalPartner OK
     * @throws ApiError
     */
    public static listLocalPartners(): CancelablePromise<Array<db_DropdownLocalPartner>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/local-partners',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
